import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  //car
  getCarPurchaseHistory: state => {
    if (typeof state.carPurchaseHistory === 'string') {
      return JSON.parse(state.carPurchaseHistory);
    }
    return qoalaStorage.getItem('carPurchaseHistory')
      ? parseIfJsonString(qoalaStorage.getItem('carPurchaseHistory'))
      : state.carPurchaseHistory || {};
  },
  getProductDetailCar: state => {
    if (!state.productDetailCar) {
      return '';
    }
    if (state.productDetailCar === 'undefined') {
      return '';
    }
    if (typeof state.productDetailCar === 'string') {
      return JSON.parse(state.productDetailCar);
    }
    return qoalaStorage.getItem('productDetailCar')
      ? parseIfJsonString(qoalaStorage.getItem('productDetailCar'))
      : state.productDetailCar;
  },
  //motor
  getMotorPurchaseHistory: state => {
    if (typeof state.motorPurchaseHistory === 'string') {
      return JSON.parse(state.motorPurchaseHistory);
    }
    return qoalaStorage.getItem('motorPurchaseHistory')
      ? parseIfJsonString(qoalaStorage.getItem('motorPurchaseHistory'))
      : state.motorPurchaseHistory || {};
  },
  getProductDetailMotor: state => {
    if (!state.productDetailMotor) {
      return '';
    }
    if (state.productDetailMotor === 'undefined') {
      return '';
    }
    if (typeof state.productDetailMotor === 'string') {
      return JSON.parse(state.productDetailMotor);
    }
    return qoalaStorage.getItem('productDetailMotor')
      ? parseIfJsonString(qoalaStorage.getItem('productDetailMotor'))
      : state.productDetailMotor;
  },
  //vehicle
  getVehiclePlate: state => {
    if (typeof state.vehiclePlate === 'string') {
      return JSON.parse(state.vehiclePlate);
    }
    return qoalaStorage.getItem('vehiclePlate')
      ? parseIfJsonString(qoalaStorage.getItem('vehiclePlate'))
      : state.vehiclePlate || [];
  },
  getVehicleBrand: state => {
    if (typeof state.vehicleBrand === 'string') {
      return JSON.parse(state.vehicleBrand);
    }
    return qoalaStorage.getItem('vehicleBrand')
      ? parseIfJsonString(qoalaStorage.getItem('vehicleBrand'))
      : state.vehicleBrand || [];
  },
  getVehicleModel: state => {
    if (typeof state.vehicleModel === 'string') {
      return JSON.parse(state.vehicleModel);
    }
    return qoalaStorage.getItem('vehicleModel')
      ? parseIfJsonString(qoalaStorage.getItem('vehicleModel'))
      : state.vehicleModel || [];
  },
  getVehicleSeries: state => {
    if (typeof state.vehicleSeries === 'string') {
      return JSON.parse(state.vehicleSeries);
    }
    return qoalaStorage.getItem('vehicleSeries')
      ? parseIfJsonString(qoalaStorage.getItem('vehicleSeries'))
      : state.vehicleSeries || [];
  },
  getDocumentsType: state => {
    if (typeof state.documentsType === 'string') {
      return JSON.parse(state.documentsType);
    }
    return qoalaStorage.getItem('documentsType')
      ? parseIfJsonString(qoalaStorage.getItem('documentsType'))
      : state.documentsType || [];
  }
};
